import { Box, Divider } from '@mui/material'
import React from 'react'
import Startup from '../../../../models/startup'
import StartupHeader from './StartupHeader'
import StartupScores from './StartupScores'

interface Props {
  startup: Startup
  logoUrl?: string
  onEditStartupPressed: () => void
  onScoreNowPressed: () => void
  onViewAllScoresPressed: () => void
}

const StartupDetailsScoreSection = (props: Props) => {
  return (
    <Box 
      display='flex' 
      flexDirection='column'
      sx={{
        border: 1,
        borderColor: 'text.secondary',
        borderRadius: '16px',
        backgroundColor: '#fff'
      }}
      >
      <Box padding={1}>
        <StartupHeader logoUrl={props.logoUrl} companyName={props.startup.name} onEdit={props.onEditStartupPressed} onScoreNow={props.onScoreNowPressed} />
      </Box>
      <Divider />
      <Box padding={5}>
        <StartupScores 
          userScore={props.startup.userCommercialViabilityScore} 
          aggregateScore={props.startup.commercialViabilityScore} 
          onScoreNowPressed={props.onScoreNowPressed}
          onAllScoresPressed={props.onViewAllScoresPressed}
        />
      </Box>
    </Box>
  )  
}

export default StartupDetailsScoreSection
